/* esm.sh - micromark-util-resolve-all@2.0.1 */
function c(o,e,r){let i=[],n=-1;for(;++n<o.length;){let l=o[n].resolveAll;l&&!i.includes(l)&&(e=l(e,r),i.push(l))}return e}export{c as resolveAll};
//# sourceMappingURL=micromark-util-resolve-all.mjs.map